import React from "react";
import { CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useDealer } from "../hooks/useDealer";
import { DealerForm } from "../DealerForm";
import { DealerRiskProfile } from "../DealerRiskProfile";
import { useCrumb } from "@poseidon/ui/app/crumbs/CrumbContext";
import { WithDoc } from "@poseidon/firebase/components/WithDoc";
import TabPanels from "@poseidon/ui/components/TabPanels";

export default function EditDealer() {
  const { dealerId } = useParams();
  const { dealer, loading, error } = useDealer(dealerId);
  const { setError } = useErrorMessage();

  useCrumb("/dealers/:dealerId", {
    to: `/dealers/:dealerId`,
    Component: () => (
      <WithDoc
        docRef={`dealers/${dealerId}`}
        Component={({ data: dealer }) =>
          dealer.companyName || dealer.contactEmail || "Unknown"
        }
      />
    ),
  });

  if (error) {
    setError(error);
  }

  if (loading || !dealer) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }

  const tabs = [
    {
      key: "dealer",
      panelName: "Dealer",
      panel: <DealerForm dealer={dealer} />,
    },
    {
      key: "dealerRiskProfile",
      panelName: "Dealer Risk Profile",
      panel: <DealerRiskProfile dealer={dealer} />,
    },
  ];

  return <TabPanels>{tabs}</TabPanels>;
}
